export const setQueryParameters = (url: string, options: string): string => {
  const [host, query = ''] = url.split('?');
  const auto = query.split('&').filter((s) => s.includes('auto'));
  const rect = query.split('&').filter((s) => s.includes('rect'));
  const opts = [...auto, ...rect, ...options.split('&')].filter((x) => x !== '');
  return `${host}?${opts.join('&')}`;
};
